import { dayjsLocalDateSchema } from "@/utils/zod.ts";
import { convert } from "@js-joda/core";
import { z } from "zod";

export const caseTaskSchema = z.object({
    idUUID: z.string(),
    name: z.string(),
    description: z.string(),
    status: z.string(),
    duration: z.number(),
    coreRoles: z.array(z.string()),
    caseStatuses: z.array(z.string()),
    metaCreatedByPretty: z.string().nullable().optional(),
    metaCreatedWhen: z.coerce.date(),
    completedBy: z.string().nullable(),
    dateCompleted: z.coerce.date().nullable(),
    defaultNoteTag: z.string().nullable(),
    assignedBy: z.string(),
});

export const addTasksToCasesByCaseTemplateSchema = z.object({
    cases: z
        .array(
            z.object({
                id: z.string(),
                name: z.string(),
            }),
        )
        .min(1),
    caseTemplateId: z.string(),
});

export const addTaskToCasesByRoleSchema = z.object({
    duration: z.string(),
    role: z.string(),
    case: z
        .object({
            id: z.string(),
            name: z.string(),
        })
        .nullable(),
    taskTemplate: z
        .object({
            id: z.string(),
            name: z.string(),
        })
        .nullable(),
});

export const addTaskToSelfByTaskTemplateSchema = z.object({
    cases: z
        .array(
            z.object({
                id: z.string(),
                name: z.string(),
            }),
        )
        .min(1),
    taskTemplate: z.object({
        id: z.string(),
        name: z.string(),
    }),
    due: dayjsLocalDateSchema.optional().refine(
        (date) => {
            if (!date) {
                return true; // Allow undefined/null for tasks without due dates
            }
            const compareDate = convert(date).toDate();
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return compareDate > today;
        },
        {
            message: "Due date must be at least one day in the future",
        },
    ),
    duration: z.number(),
});

export const addTaskToSelfAdHocTemplateSchema = z.object({
    cases: z
        .array(
            z.object({
                id: z.string(),
                name: z.string(),
            }),
        )
        .min(1),
    adHoc: z.string(),
    due: dayjsLocalDateSchema.optional().refine(
        (date) => {
            if (!date) {
                return true; // Allow undefined/null for tasks without due dates
            }
            const compareDate = convert(date).toDate();
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return compareDate > today;
        },
        {
            message: "Due date must be at least one day in the future",
        },
    ),
    duration: z.number(),
});

export const addTaskToSelfAdHocTemplateWithCoreRoles = addTaskToSelfAdHocTemplateSchema.extend({
    coreRoles: z.array(z.string()),
});
